import { useState } from 'react';
import * as React from 'react';
import { EditBlock } from '@hungryroot/plan';
import { type ServingSize } from '@hungryroot/rest';
import { EditRecipeSizeModal } from '../EditRecipeSizeModal/EditRecipeSizeModal';

interface EditRecipeSizeBlockProps {
  testid?: string;
  id: string;
  heading: string;
  description: string;
  icon?: string | React.ReactNode;
  servingSize: ServingSize;
  confirmButtonText: string;
  onSubmit: (servingSize: ServingSize) => void;
  className: string;
  editDisabled?: boolean;
}

export const EditRecipeSizeBlock = ({
  testid,
  id,
  heading,
  description,
  icon,
  servingSize,
  confirmButtonText,
  onSubmit,
  className,
  editDisabled,
}: EditRecipeSizeBlockProps) => {
  const [isEditRecipeSizeModalOpen, setIsEditRecipeSizeModalOpen] =
    useState(false);

  return (
    <>
      <EditBlock
        className={className}
        key={id}
        testid={testid}
        heading={heading}
        description={description}
        icon={icon}
        onClick={() => setIsEditRecipeSizeModalOpen(true)}
        editDisabled={editDisabled}
      />
      {isEditRecipeSizeModalOpen && (
        <EditRecipeSizeModal
          initialValue={servingSize}
          isOpen={isEditRecipeSizeModalOpen}
          onCancel={() => setIsEditRecipeSizeModalOpen(false)}
          confirmButtonText={confirmButtonText}
          onSubmit={(servingSize) => {
            onSubmit(servingSize);
            setIsEditRecipeSizeModalOpen(false);
          }}
        />
      )}
    </>
  );
};
